module.exports = __webpack_public_path__ + "static/media/iconTestActive.36c4dce4.svg";